



import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import { Field } from 'formik';
import walkthroughIds from '../../../walkthroughIds';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const OperatorConnectNameField = ({ darkMode, errors, touched, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  console.log(errors, touched);
  return (
    <FormControl
      isInvalid={!!errors.name && touched.name}
      sx={{ margin: '0 !important' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
        <Box>
          <FormLabel sx={formLabelStyling(darkMode)}>
            Name <span style={{ color: '#e53e3e' }}>*</span>
          </FormLabel>
          <Text sx={descriptionStyling} maxWidth={250}>
            Enter a name for this Operator Connect profile.
          </Text>
        </Box>
        <Box flex="1" minWidth="450px">
          <VStack width="100%" alignItems="normal">
            <Field
              component={NameField}
              id="name"
              name="name"
              validate={value => !value && 'Name is required'}
              error={errors.name}
              walkthroughid={walkthroughIds.adminsGeneral?.ufFirstName}
              {...props}
            />
          </VStack>
        </Box>
        {isHovered && (
          <FieldToolTip
            label="Enter a name."
            ariaLabel="operator-connect-name-tip"
            left="25px"
            top="25px"
          />
        )}
      </Stack>
    </FormControl>
  );
};

export default OperatorConnectNameField;
